import React from "react";
import TopNav from "../components/TopNav";
import BottomNav from "../components/BottomNav";
import Footer from "../components/footer/Footer";

function Term() {
  const styles = {
    page: {
      background: "#f7f8fb",
      minHeight: "100vh",
    },
    container: {
      maxWidth: 980,
      margin: "0 auto",
      padding: "28px 16px 60px",
    },
    card: {
      background: "#ffffff",
      border: "1px solid #e8ebf2",
      borderRadius: 14,
      padding: "26px 22px",
      boxShadow: "0 6px 18px rgba(16, 24, 40, 0.06)",
    },
    title: {
      fontSize: 34,
      lineHeight: 1.2,
      margin: "0 0 10px",
      color: "#0f172a",
      letterSpacing: "-0.4px",
    },
    updated: {
      margin: "0 0 18px",
      color: "#64748b",
      fontSize: 14,
    },
    lead: {
      padding: "14px 16px",
      borderRadius: 12,
      background: "#f1f5ff",
      border: "1px solid #dbe7ff",
      color: "#1e3a8a",
      margin: "14px 0 22px",
      lineHeight: 1.7,
      fontSize: 15,
    },
    section: {
      marginTop: 22,
      paddingTop: 18,
      borderTop: "1px solid #eef1f6",
    },
    h2: {
      fontSize: 18,
      margin: "0 0 10px",
      color: "#111827",
    },
    p: {
      margin: "0 0 12px",
      color: "#334155",
      lineHeight: 1.85,
      fontSize: 15.5,
    },
    ul: {
      margin: "8px 0 12px 18px",
      padding: 0,
      color: "#334155",
      lineHeight: 1.85,
      fontSize: 15.5,
    },
    link: {
      color: "#2563eb",
      textDecoration: "none",
      fontWeight: 600,
    },
    smallNote: {
      fontSize: 13,
      color: "#64748b",
      marginTop: 10,
    },
  };

  return (
    <div style={styles.page}>
      <TopNav />
      <BottomNav />

      <main style={styles.container}>
        <section style={styles.card}>
          <h1 style={styles.title}>Terms and Conditions</h1>
          <p style={styles.updated}>Last updated: {new Date().toLocaleDateString()}</p>

          <div style={styles.lead}>
            <strong>
              PLEASE READ THESE TERMS AND CONDITIONS CAREFULLY BEFORE USING THIS
              SITE. THEY LAY OUT THE RULES FOR USING OUR SERVICES.
            </strong>
          </div>

          <div style={styles.section}>
            <h2 style={styles.h2}>Who We Are and How to Contact Us</h2>
            <p style={styles.p}>
              Site: Makkaan.com
              <br />
              We/Us/Our: Makkaan.com, a company registered in Pakistan with a
              registered office at Jackson Heights 2nd and 3rd Floor Main GT Road
              Rawalpindi.
              <br />
              Contact Us:
              <br />
              Email:{" "}
              <a style={styles.link} href="mailto:info@makkaan.com">
                info@makkaan.com
              </a>
              <br />
              UAN: +92 331-11-11-049
            </p>
          </div>

          <div style={styles.section}>
            <h2 style={styles.h2}>How These Terms Apply to You</h2>
            <p style={styles.p}>
              By using the Site, you confirm that you accept these Terms and agree to
              comply with them.
              <br />
              If you do not agree, please do not use the Site.
              <br />
              We recommend that you print a copy of these Terms for your records.
              <br />
              These Terms may change over time.
              <br />
              Each time you visit the Site, you agree to check for any updates.
            </p>
          </div>

          <div style={styles.section}>
            <h2 style={styles.h2}>Other Terms That May Apply to You</h2>
            <p style={styles.p}>
              In addition to these Terms, the following additional terms and
              conditions (“Associated Terms”) will apply to your use of the Site:
            </p>
            <ul style={styles.ul}>
              <li>Our Cookie Policy</li>
              <li>Our Acceptable Use Policy</li>
              <li>Our Member Terms (if you are a registered Member)</li>
            </ul>
          </div>

          <div style={styles.section}>
            <h2 style={styles.h2}>The Site</h2>
            <ul style={styles.ul}>
              <li>We may update and change the Site as necessary.</li>
              <li>The Site is available to users free of charge.</li>
              <li>
                While we strive to ensure the Site remains available, we cannot
                guarantee uninterrupted access.
              </li>
              <li>We may suspend or restrict access at times.</li>
              <li>
                You are responsible for ensuring that anyone accessing the Site
                through your internet connection is aware of these Terms and complies
                with them.
              </li>
              <li>
                The Site is intended for international use, and you must be over the
                age of 18 to access it.
              </li>
              <li>
                You agree to keep any security credentials (like passwords and
                usernames) confidential and not share them with others.
              </li>
              <li>
                We reserve the right to disable your access if we suspect any breach
                of these Terms.
              </li>
            </ul>
          </div>

          <div style={styles.section}>
            <h2 style={styles.h2}>Using Material on the Site</h2>
            <p style={styles.p}>
              We own or are licensed to use all intellectual property rights in the
              Site and its materials. These works are protected globally by copyright
              laws, and all rights are reserved.
              <br />
              You may print one copy and download extracts of any page(s) from the
              Site for personal use only.
              <br />
              Modification of any materials is prohibited.
              <br />
              For commercial use of materials, please obtain written permission from
              us.
            </p>
          </div>

          <div style={styles.section}>
            <h2 style={styles.h2}>Content Accuracy</h2>
            <p style={styles.p}>
              The content on this Site is provided for general information purposes
              only and should not be considered professional advice. Always seek
              appropriate advice before taking action based on information on this
              Site.
              <br />
              While we aim to keep the information up-to-date, we make no guarantees
              regarding accuracy or timeliness.
            </p>
          </div>

          <div style={styles.section}>
            <h2 style={styles.h2}>Links to Other Websites</h2>
            <p style={styles.p}>
              Links to third-party websites are provided for your convenience. We do
              not endorse or assume any responsibility for these sites.
            </p>
          </div>

          <div style={styles.section}>
            <h2 style={styles.h2}>User-Generated Content</h2>
            <p style={styles.p}>
              The Site may include content uploaded by users. We do not verify or
              approve this content, and any opinions expressed do not necessarily
              reflect our views.
              <br />
              If you have concerns about user-generated content, please contact us at
              +92 331-11-11-049.
            </p>
          </div>

          <div style={styles.section}>
            <h2 style={styles.h2}>Uploading Content to the Site</h2>
            <p style={styles.p}>
              When you upload content, you agree to comply with our Acceptable Use
              Policy. By uploading content, you grant us a limited license to use and
              distribute that content.
              <br />
              We have the right to remove any content that does not comply with our
              standards.
            </p>
          </div>

          <div style={styles.section}>
            <h2 style={styles.h2}>Our Liability</h2>
            <p style={styles.p}>
              We do not exclude liability where it would be unlawful to do so,
              including for death or personal injury due to our negligence.
              <br />
              If you are a business user, we exclude all implied terms and conditions,
              and we are not liable for indirect or consequential losses.
              <br />
              If you are a consumer user, we only provide the Site for personal use,
              and we have no liability for business losses.
            </p>
          </div>

          <div style={styles.section}>
            <h2 style={styles.h2}>Security Responsibilities</h2>
            <p style={styles.p}>
              We do not guarantee that the Site is free from viruses.
              <br />
              You are responsible for configuring your technology to access the Site
              safely.
              <br />
              You must not introduce harmful material or attempt unauthorized access
              to the Site.
            </p>
          </div>

          <div style={styles.section}>
            <h2 style={styles.h2}>Links to Our Site</h2>
            <p style={styles.p}>
              You may link to our homepage, provided that it is done fairly and
              legally without damaging our reputation. We reserve the right to
              withdraw linking permission at any time.
            </p>
          </div>

          <div style={styles.section}>
            <h2 style={styles.h2}>Governing Law</h2>
            <p style={styles.p}>
              These Terms and their formation are governed by the laws of Pakistan,
              and any disputes will be subject to the exclusive jurisdiction of the
              courts of Pakistan.
            </p>
          </div>

          <div style={styles.section}>
            <h2 style={styles.h2}>Definitions</h2>
            <p style={styles.p}>In these Terms, the following definitions apply:</p>
            <ul style={styles.ul}>
              <li>You, Your: The person visiting the Site.</li>
              <li>User: Any person using the Site.</li>
              <li>Member: A User who registers on the Site.</li>
              <li>Content: All information provided on the Site.</li>
              <li>Terms: These terms and conditions and any Associated Terms.</li>
            </ul>
          </div>

          <div style={styles.section}>
            <h2 style={styles.h2}>Cookie Policy</h2>
            <p style={styles.p}>
              Our website uses cookies to enhance your experience. By continuing to
              browse the Site, you consent to our use of cookies. For more details,
              please see our Cookie Policy.
            </p>
            <p style={styles.smallNote}>
              Tip: Add links to Cookie Policy / Acceptable Use Policy pages if you
              have separate routes for them.
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default Term;
